import { QueryClient } from '@tanstack/react-query'

/**
 * React Query Client Configuration
 *
 * Default options:
 * - 5-minute stale time (data stays fresh for 5 min)
 * - No refetch on window focus (can be enabled per-query)
 * - Retry failed queries 1 time
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
})
